module.exports = __webpack_public_path__ + "static/img/OM.94e3b41b.png";